export { default } from "./SkeletonShadowTeamView";
